$(function () {
    $(".ar-table-of-contents-block")
        .on("click", ".ar-table-of-contents-block__menu-opener", function (e) {
            e.preventDefault();

            $(this)
                .closest(".ar-table-of-contents-block__menu-item")
                .toggleClass("ar-table-of-contents-block__menu-item_open");
        })
        .on("mouseenter", ".ar-table-of-contents-block__menu-link", function (e) {
            var targetImageId = $(this).data("image-id");

            if (targetImageId) {
                $(".ar-table-of-contents-block__image", $(this).closest(".ar-table-of-contents-block")).each(function (index, element) {
                    var $element = $(element);
                    var imageId = $element.data("image-id");

                    if (imageId === targetImageId) {
                        $element.css("opacity", 1);
                    }
                    else {
                        $element.css("opacity", 0);
                    }
                });
            }
        });
});